<ng-container [ngSwitch]="type">
  <input *ngSwitchCase="'input'" type="text" class="form-control form-control-plaintext" [value]="band" disabled style="padding-left:15px;"/>
  <span *ngSwitchCase="'valueOnly'">{{ band }}</span>
  <div *ngSwitchCase="'chip-small'" class="{{className}} rdsap-chip-small" style="display:inline-block;">{{band}}</div>
  <div *ngSwitchCase="'chip-medium'" class="{{className}} rdsap-chip-medium" style="display:inline-block;">{{band}}</div>
  <div *ngSwitchCase="'chip-large'" class="{{className}} rdsap-chip-large" style="display:inline-block;">{{band}}</div>
  <h1 *ngSwitchDefault>Type attribute required in template function: rdsap-band.component.html</h1>
</ng-container>
